import React, { useEffect } from 'react'
import styled from '@emotion/styled'

import { BrowserUtils, QuestionUtils, ArrayUtils } from '../../utils/siteUtils'
import { TagHorizontal } from '../compiledSVG/conditionV2/tags'

export default ({ anyAnswered, svgIcons, setShowModal, conditionQuestions = [], setBadgeCnt, secondaryTabExterior, tab }) => {
  const isDesktop = BrowserUtils.isDesktop()
  const representativeQuestion = conditionQuestions.filter(question => question.item.toLowerCase().startsWith(svgIcons.length > 0 && svgIcons[0].toLowerCase()))[0]
  const dividedArray = isDesktop ? ArrayUtils.divideArray(svgIcons, ArrayUtils.findLen(svgIcons.length)) : [svgIcons]

  var cnt = 0

  function onClickFunc(icon, repQ, divArr, showModal) {
    repQ && showModal && setShowModal({ name: icon, subsectionCode: repQ.subsectionCode })

    cnt = divArr
      .map(subArr => {
        const sub = subArr
          .map(icon => ({
            [icon]: anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, icon, repQ && repQ.subsectionCode))
          }))
          .reduce((acc, ndx) => {
            if (Object.values(ndx)[0]) acc++
            return acc
          }, 0)
        return sub
      })
      .reduce((acc, curr) => acc + curr, 0)

    setBadgeCnt(item => ({ ...item, [icon]: cnt }))
  }

  useEffect(() => {
    representativeQuestion && onClickFunc('Brakes', representativeQuestion, dividedArray, false)
  }, [representativeQuestion, anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, 'Brakes', representativeQuestion && representativeQuestion.subsectionCode))])

  return (
    (secondaryTabExterior === 'Driver' || secondaryTabExterior === 'Passenger') && tab === 'Exterior' && (
      <IconDiv>
        {dividedArray.map((subArray, i) => (
          <SubDiv key={i} isDesktop={isDesktop}>
            {subArray.map((icon, index) => {
              const questions = QuestionUtils.getAssociatedQuestions(conditionQuestions, icon, representativeQuestion && representativeQuestion.subsectionCode)
              return questions.length > 0 && <TagHorizontal key={index} text={[icon]} isSelected={anyAnswered(questions)} onClick={() => onClickFunc(icon, representativeQuestion, dividedArray, true)}></TagHorizontal>
            })}
          </SubDiv>
        ))}
      </IconDiv>
    )
  )
}

const SubDiv = styled.div`
  display: flex;
  justify-content: space-around;
  > div {
    margin-left: 10px;
  }
`
const IconDiv = styled.div`
  display: flex;
  justify-content: center;
`
